import { useNavigate } from 'react-router-dom';
import blurTop from '../../assets/splashScreen/Blur.svg'
import { LogIn, UserPlus, Zap, AlertTriangle } from 'lucide-react';
import { useState } from 'react';
import { API_BASE_URL } from '../../config/api';



const countryCodes = [
    { code: 'NG', flag: 'NG', dialCode: '+234' },

    // Add more country codes as needed
];
// export default function Signup() {

//     const navigate = useNavigate()
//     // Assume 'blurTop' is imported from somewhere, e.g., import blurTop from '../assets/blur-top.png';

//     return (
//         // Change text color to a dark one (e.g., gray-800 or black) for contrast on the white background.
//         <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">

//             {/* ADDED IMAGE AT THE TOP OF THE SCREEN */}
//             <img
//                 src={blurTop}
//                 alt=""
//                 // These classes position the image absolutely at the top-left corner,
//                 // make it full width, and ensure it doesn't interfere with clicks.
//                 className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none"
//             />

//             <h1 className="text-3xl font-bold text-[#307CF8]">Sign up</h1>
//             <p className="text-gray-500 text-sm mt-1">Create an account to get started</p>

//             <form className="mt-8 space-y-6">

//                 {/* Full Name */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Full name</label>
//                     <input
//                         type="text"
//                         placeholder="Enter your full name"
//                         // Adjusted classes: Dark text, white background, gray border
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400"
//                     />
//                 </div>

//                 {/* Email */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Email Address</label>
//                     <input
//                         type="email"
//                         placeholder="name@email.com"
//                         // Adjusted classes: Dark text, white background, gray border
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400"
//                     />
//                 </div>

//                 {/* Phone */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Phone Number</label>
//                     {/* Adjusted classes: Dark text, white background, gray border for the container */}
//                     <div className="mt-1 flex items-center bg-white border border-gray-300 rounded-xl px-3 py-3 space-x-3">
//                         <span className="text-lg">🇮🇳</span>
//                         <input
//                             placeholder="+91 9876543210"
//                             // Adjusted classes: Dark text, transparent background
//                             className="w-full bg-transparent outline-none text-gray-800 placeholder:text-gray-400"
//                         />
//                     </div>
//                 </div>

//                 {/* Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Password</label>
//                     <input
//                         type="password"
//                         placeholder="Create a password"
//                         // Adjusted classes: Dark text, white background, gray border
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400"
//                     />
//                 </div>

//                 {/* Confirm Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Confirm password</label>
//                     <input
//                         type="password"
//                         placeholder="Confirm password"
//                         // Adjusted classes: Dark text, white background, gray border
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400"
//                     />
//                 </div>

//                 {/* Checkbox */}
//                 <label className="flex items-center space-x-3">
//                     <input type="checkbox" className="w-5 h-5 accent-blue-600 border border-gray-300" />
//                     {/* Adjusted text color for readability on white background */}
//                     <span className="text-gray-600 text-sm">
//                         I’ve read and agree with the{" "}
//                         <span className="text-blue-600">Terms and Conditions</span> and the{" "}
//                         <span className="text-blue-600">Privacy Policy</span>.
//                     </span>
//                 </label>

//                 {/* Submit */}
//                 <button className="w-full bg-blue-600 py-3 rounded-xl font-semibold text-white"
//                     onClick={() => {

//                         navigate("/otpconfirm");
//                     }} >
//                     Login
//                 </button>

//                 {/* Sign in link */}
//                 <p className="text-center text-gray-600 text-sm">
//                     Already have an account?{" "}
//                     <span className="text-blue-600 font-semibold cursor-pointer">Sign in</span>
//                 </p>
//             </form>
//         </div>
//     );
// }



// function Signup() {

//     const navigate = useNavigate()

//     const handleSignUp = (e) => {
//         e.preventDefault();
//         // Navigates to OTP confirmation screen after signing up
//         navigate("/otpconfirm");
//     }

//     return (
//         <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">

//             {/* ADDED IMAGE AT THE TOP OF THE SCREEN */}
//             <img
//                 src={blurTop}
//                 alt="Decorative background blur"
//                 className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
//             />

//             <h1 className="text-3xl font-bold text-[#307CF8]">Sign up</h1>
//             <p className="text-gray-500 text-sm mt-1">Create an account to get started</p>

//             <form className="mt-8 space-y-6">

//                 {/* Full Name */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Full name</label>
//                     <input
//                         type="text"
//                         placeholder="Enter your full name"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Email */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Email Address</label>
//                     <input
//                         type="email"
//                         placeholder="name@email.com"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Phone */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Phone Number</label>
//                     <div className="mt-1 flex items-center bg-white border border-gray-300 rounded-xl px-3 py-3 space-x-3 focus-within:border-blue-600 shadow-sm transition">
//                         <span className="text-lg">🇮🇳</span>
//                         <input
//                             placeholder="+91 9876543210"
//                             className="w-full bg-transparent outline-none text-gray-800 placeholder:text-gray-400"
//                         />
//                     </div>
//                 </div>

//                 {/* Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Password</label>
//                     <input
//                         type="password"
//                         placeholder="Create a password"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Confirm Password */}
//                 <div>
//                     <label className="text-gray-600 text-sm">Confirm password</label>
//                     <input
//                         type="password"
//                         placeholder="Confirm password"
//                         className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
//                     />
//                 </div>

//                 {/* Checkbox */}
//                 <label className="flex items-center space-x-3">
//                     <input type="checkbox" className="w-5 h-5 accent-blue-600 border border-gray-300 rounded" />
//                     <span className="text-gray-600 text-sm">
//                         I’ve read and agree with the{" "}
//                         <span className="text-blue-600 cursor-pointer hover:underline">Terms and Conditions</span> and the{" "}
//                         <span className="text-blue-600 cursor-pointer hover:underline">Privacy Policy</span>.
//                     </span>
//                 </label>

//                 {/* Submit */}
//                 <button className="w-full bg-blue-600 py-3 rounded-xl font-semibold text-white shadow-lg shadow-blue-500/50 hover:bg-blue-700 transition"
//                     onClick={handleSignUp} >
//                     <UserPlus className="w-5 h-5 inline mr-2 align-sub" />
//                     Sign Up
//                 </button>

//                 {/* Sign in link - UPDATED */}
//                 <p className="text-center text-gray-600 text-sm">
//                     Already have an account?{" "}
//                     <span 
//                         className="text-blue-600 font-semibold cursor-pointer hover:underline"
//                         onClick={() => navigate("/signin")}
//                     >
//                         Sign in
//                     </span>
//                 </p>
//             </form>
//         </div>
//     );
// }
// export default Signup




// --- 2. Signup Component (Registration Form) ---
function Signup() {
    const navigate = useNavigate();
    const API_URL = `${API_BASE_URL}/auth/register`;


    const formatNigerianPhone = (value) => {
        // keep only digits
        let cleaned = value.replace(/\D/g, '');

        // remove leading 0 if user types it
        if (cleaned.startsWith('0')) {
            cleaned = cleaned.slice(1);
        }

        // max 10 digits
        return cleaned.slice(0, 10);
    };

//    const isNigerianPhone = (input) => /^[789]\d{9}$/.test(input);

const normalizePhone = (value) => {
  let cleaned = value.replace(/\D/g, '');

  if (cleaned.startsWith('0')) {
    cleaned = cleaned.slice(1);
  }

  return cleaned.slice(0, 10);
};

const isNigerianPhone = (phone) => 
    /^[789]\d{9}$/.test(phone);

    const [formData, setFormData] = useState({
        full_name: '', // Combined name field
        email: '',
        password: '',
        password_confirmation: '',
        phone: '',
        phone_code: 'NG', // Default to India
        type: 'PUBLIC', // Fixed based on required payload
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSignUp = async (e) => {
        e.preventDefault();
        setError(null);


        if (!isNigerianPhone(formData.phone)) {
            setError("Please enter a valid Nigerian phone number.");
            return;
        }

        // Client-side validation check
        if (formData.password !== formData.password_confirmation) {
            setError("Passwords do not match.");
            return;
        }

        setIsLoading(true);

        try {
            // Logic to split Full Name into First Name and Last Name
            const nameParts = formData.full_name.trim().split(/\s+/);
            const first_name = nameParts[0] || '';
            // Everything after the first word is considered the last name
            const last_name = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

            const payload = {
                first_name: first_name,
                last_name: last_name,
                email: formData.email,
                password: formData.password,
                password_confirmation: formData.password_confirmation,
                phone: `234${formData.phone}`,
                phone_code: formData.phone_code,
                type: formData.type,
            };

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (response.ok) {
                console.log('Registration Successful:', result);
                // Navigates to OTP confirmation screen after successful registration
                // NOTE: Using mockEmail in OTPConfirmPage. In a real app, you would pass the registered email here.
                navigate("/signin");
            } else {
                // Handle API error messages (e.g., validation failure)
               let errorMessage = "Something went wrong.";

if (result.data) {
  // convert all field errors into one string
  errorMessage = Object.values(result.data)
    .flat()
    .join(" ");
} else if (result.message) {
  errorMessage = result.message;
}

setError(errorMessage);

            }
        } catch (err) {
            console.error('Network Error:', err);
            setError('Network error or server unreachable. Please ensure the API is running at 127.0.0.1:8000.');
        } finally {
            setIsLoading(false);
        }
    };

const phoneInvalid =
  formData.phone.length > 0 && !isNigerianPhone(formData.phone);



    return (
        // <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">
        <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden max-w-md mx-auto">
            {/* ADDED IMAGE AT THE TOP OF THE SCREEN */}
            <img
                src={blurTop}
                alt="Decorative background blur"
                className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
            />

            <h1 className="text-3xl font-bold text-[#307CF8]">Sign up</h1>
            <p className="text-gray-500 text-sm mt-1">Create an account to get started</p>

            {/* Error Message Display */}
            {error && (
                <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-xl flex items-start text-sm">
                    <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
                    <p className="font-medium">Error: {error}</p>
                </div>
            )}

            <form className="mt-8 space-y-6" onSubmit={handleSignUp}>

                {/* Full Name (Reverted to single field) */}
                <div>
                    <label className="text-gray-600 text-sm">Full Name</label>
                    <input
                        type="text"
                        name="full_name"
                        value={formData.full_name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        required
                        className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                    />
                </div>

                {/* Email */}
                <div>
                    <label className="text-gray-600 text-sm">Email Address</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="name@email.com"
                        required
                        className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                    />
                </div>

                {/* Phone - Country Code Selector + Number Input */}
                {/* <div>
                    <label className="text-gray-600 text-sm">Phone Number</label>
                    <div className="mt-1 flex items-center bg-white border border-gray-300 rounded-xl shadow-sm focus-within:border-blue-600 transition">
                        
                        <select
                            name="phone_code"
                            value={formData.phone_code}
                            onChange={handleChange}
                            className="bg-transparent text-gray-800 p-3 rounded-l-xl outline-none border-r border-gray-200 cursor-pointer"
                        >
                            {countryCodes.map(c => (
                                <option key={c.code} value={c.code}>
                                    {c.flag} {c.dialCode}
                                </option>
                            ))}
                        </select>
                        
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="9876543210"
                            required
                            className="w-full bg-transparent outline-none text-gray-800 p-3 placeholder:text-gray-400 rounded-r-xl"
                        />
                        <input
    type="tel"
    name="phone"
    value={formData.phone}
    onChange={(e) => {
        // allow only numbers
        const value = e.target.value.replace(/\D/g, '');
        setFormData({ ...formData, phone: value });
    }}
    maxLength={10}
    placeholder="8012345678"
    required
    className="w-full bg-transparent outline-none text-gray-800 p-3 placeholder:text-gray-400 rounded-r-xl"
/>

                    </div>
                </div> */}
              
                  
                  
<div>

                         <label className="text-gray-600 text-sm">Phone Number</label>
                    <div className={`mt-1 flex items-center bg-white border border-gray-300 rounded-xl shadow-sm focus-within:border-blue-600 transition  ${phoneInvalid ? "border-red-500" : "border-gray-300 focus-within:border-blue-600"}`}>
                        
                        <select
                            name="phone_code"
                            value={formData.phone_code}
                            onChange={handleChange}
                            className="bg-transparent text-gray-800 p-3 rounded-l-xl outline-none border-r border-gray-200 cursor-pointer"
                        >
                            {countryCodes.map(c => (
                                <option key={c.code} value={c.code}>
                                    {c.flag} {c.dialCode}
                                </option>
                            ))}
                        </select>

                        <input
      type="tel"
      name="phone"
      value={formData.phone}
      onChange={(e) =>
        setFormData({
          ...formData,
        //   phone: e.target.value.replace(/\D/g, '').slice(0, 10),
         phone: normalizePhone(e.target.value),
        })
      }
      placeholder="8012345678"
      inputMode="numeric"
      className="w-full bg-transparent outline-none text-gray-800 p-3"
      required
    />
  
                    </div>

                    {/* Live Error */}
                    {phoneInvalid && (
                        <p className="text-red-500 text-sm mt-1">
                            Enter a valid Nigerian phone number
                        </p>
                    )}
                </div>

                {/* Password */}
                <div>
                    <label className="text-gray-600 text-sm">Password</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Create a password"
                        required
                        className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                    />
                </div>

                {/* Confirm Password */}
                <div>
                    <label className="text-gray-600 text-sm">Confirm password</label>
                    <input
                        type="password"
                        name="password_confirmation"
                        value={formData.password_confirmation}
                        onChange={handleChange}
                        placeholder="Confirm password"
                        required
                        className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition"
                    />
                </div>

                {/* Checkbox */}
                <label className="flex items-center space-x-3">
                    <input type="checkbox" required className="w-5 h-5 accent-blue-600 border border-gray-300 rounded" />
                    <span className="text-gray-600 text-sm">
                        I’ve read and agree with the{" "}
                        <span className="text-blue-600 cursor-pointer hover:underline">Terms and Conditions</span> and the{" "}
                        <span className="text-blue-600 cursor-pointer hover:underline">Privacy Policy</span>.
                    </span>
                </label>

                {/* Submit */}
                <button
                    type="submit"
                    className={`w-full py-3 rounded-xl font-semibold text-white transition-colors shadow-lg ${isLoading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/50'
                        }`}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        'Registering...'
                    ) : (
                        <>
                            <UserPlus className="w-5 h-5 inline mr-2 align-sub" />
                            Sign Up
                        </>
                    )}
                </button>

                {/* Sign in link - UPDATED */}
                <p className="text-center text-gray-600 text-sm">
                    Already have an account?{" "}
                    <span
                        className="text-blue-600 font-semibold cursor-pointer hover:underline"
                        onClick={() => navigate("/signin")}
                    >
                        Sign in
                    </span>
                </p>
            </form>
        </div>
    );
}

export default Signup
